import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "15px 30px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  responsiveStyles: {
    tablet: {
      padding: "15px 10px",
    },
    mobile: {
      padding: "15px 10px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "1270px",
        margin: "0 auto",
      },
      children: [
        {
          id: generateId(),
          type: "logo" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            justifyContent: "space-between",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "FORTI",
              styles: {
                fontSize: "32px",
                fontWeight: "bold",
                color: "forground",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "GOLD",
              styles: {
                fontSize: "32px",
                fontWeight: "normal",
                color: "forground",
                margin: "0",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            alignItems: "center",
            gap: "64px",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                backgroudColor: "#ffffff00",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Benefits",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundColor: "#FBBC04",
                color: "forground",
                padding: "16px 24px",
                borderRadius: "16px",
                fontWeight: "600",
                fontStyle: "normal",
                fontSize: "20px",
                cursor: "pointer",
              },
            },
          ],
        },
        //Hamburger Button
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "none", // Hidden on desktop
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            border: "none",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            cursor: "pointer",
            marginLeft: "12px",
          },
          responsiveStyles: {
            tablet: {
              display: "flex",
            },
            mobile: {
              display: "flex",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/hamburger.svg",
              alt: "avatar1",
              styles: {
                width: "20px",
                height: "20px",
                objectContain: "contain",
                display: "block",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createInfoHeaderSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    padding: "93px 10px",
    backgroundColor: "#F7F7F7",
    color: "forground",
    backdropFilter: "blur(14.3px)",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "60px 20px" },
    mobile: { padding: "16px 20px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1382px",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            mobile: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Terms and Conditions",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "70px",
                fontStyle: "normal",
                fontWeight: 800,
                lineHeight: "80px",
                letterSpacing: "-2.1px",
                textAlign: "left",
                margin: 0,
                color: "forground",
              },
              responsiveStyles: {
                desktop: { fontSize: "60px", lineHeight: "60px" },
                tablet: { fontSize: "50px", lineHeight: "50px" },
                mobile: {
                  fontSize: "45px",
                  lineHeight: "45px",
                  fontWeight: 700,
                },
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Date Effective: April 13, 2025",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "40px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "80px",
                letterSpacing: "-1.2px",
                textAlign: "left",
                margin: 0,
                color: "forground",
              },
              responsiveStyles: {
                desktop: { fontSize: "34px", lineHeight: "34px" },
                tablet: { fontSize: "34px", lineHeight: "34px" },
                mobile: { fontSize: "25px", lineHeight: "25px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

type HeadingSize = "large" | "small";

const termsSections: {
  heading: string;
  headingSize: HeadingSize;
  contents: string[];
}[] = [
  {
    heading: "Terms and Conditions",
    headingSize: "large",
    contents: [
      'Welcome to FortiGold.com ("we," "us," or "our"). By accessing this website and/or purchasing any products from us, you agree to be bound by the following Terms and Conditions. Please read them carefully. If you do not agree with any part of these terms, please do not use our website.',
    ],
  },
  {
    heading: "1. Use of This Website",
    headingSize: "small",
    contents: [
      "By using FortiGold.com, you confirm that you are at least 18 years old and legally capable of entering into a binding contract. You agree to use this website only for lawful purposes and in a way that does not infringe the rights of others or restrict their use and enjoyment of the site.",
      "You are not permitted to modify, copy, distribute, reproduce, publish, license, or sell any information, products, or services obtained from this site without our written consent.",
    ],
  },
  {
    heading: "2. Product Information and Medical Disclaimer",
    headingSize: "small",
    contents: [
      "Our products are dietary supplements and are not intended to diagnose, treat, cure, or prevent any disease. The information on this website is provided for general informational purposes only and is not medical advice. Always consult with a qualified healthcare professional before starting any new supplement, especially if you are pregnant, nursing, taking medication, or have a medical condition.",
      "Statements on this website have not been evaluated by the Food and Drug Administration (FDA).",
    ],
  },
  {
    heading: "3. Order Acceptance and Payment",
    headingSize: "small",
    contents: [
      "By placing an order, you agree that all information provided is accurate, complete, and current. We reserve the right to refuse or cancel any order at our sole discretion, including but not limited to: pricing errors, suspicion of fraud, or product availability.",
      "All payments are processed securely via DigiStore24 or another trusted third-party payment provider. FortiGold.com does not store or have direct access to your payment information.",
    ],
  },
  {
    heading: "4. Shipping and Delivery",
    headingSize: "small",
    contents: [
      "Orders are typically processed within 1–3 business days. Delivery times may vary based on location and shipping method selected at checkout. For international orders, additional customs fees or taxes may apply, which are the responsibility of the buyer.",
    ],
  },
  {
    heading: "5. Refund Policy",
    headingSize: "small",
    contents: [
      "Your satisfaction matters to us. If you're not happy with your purchase, please review our full Refund Policy (linked in the footer of our site) for instructions on how to request a return or refund. Eligibility may depend on the time since purchase and condition of the product.",
    ],
  },
  {
    heading: "6. Intellectual Property",
    headingSize: "small",
    contents: [
      "All content on this website—including text, graphics, images, video, logos, product names, and trademarks—is the property of FortiGold.com or its licensors and is protected by copyright, trademark, and other intellectual property laws.",
      "You may not copy, reproduce, or use any content from this site without written permission, except for personal, non-commercial use.",
    ],
  },
  {
    heading: "7. Limitation of Liability",
    headingSize: "small",
    contents: [
      "To the maximum extent permitted by law, FortiGold.com and its owners, affiliates, and employees will not be liable for any direct, indirect, incidental, or consequential damages resulting from your use of this website or products purchased through it. This includes, but is not limited to, loss of income, personal injury, or data loss, even if we were advised such damages were possible.",
    ],
  },
  {
    heading: "8. Indemnification",
    headingSize: "small",
    contents: [
      "You agree to indemnify and hold harmless FortiGold.com, its affiliates, officers, employees, and agents from any claims, damages, liabilities, and expenses arising from your use of the website, your violation of these Terms, or your infringement of any intellectual property or other rights.",
    ],
  },
  {
    heading: "9. Third-Party Links",
    headingSize: "small",
    contents: [
      "This website may contain links to third-party websites or services. We are not responsible for the content, terms, or privacy practices of those sites. Use of third-party sites is at your own risk.",
    ],
  },
  {
    heading: "10. Modifications",
    headingSize: "small",
    contents: [
      "We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to this page. Your continued use of the site constitutes your acceptance of any modifications.",
    ],
  },
  {
    heading: "11. Governing Law",
    headingSize: "small",
    contents: [
      "These Terms shall be governed by and construed in accordance with the laws of the United States. Any disputes arising out of these Terms will be handled in the appropriate courts located in the U.S.",
    ],
  },
  {
    heading: "12. Contact Information",
    headingSize: "small",
    contents: [
      'If you have any questions about these Terms or anything else on our site, feel free to reach out: <a href="mailto:support@fortigold.com">📧<b>support@fortigold.com</b></a>.',
    ],
  },
];

const getHeadingStyles = (size: HeadingSize) =>
  size === "large"
    ? {
        color: "forground",
        fontFamily: "Poppins, sans-serif",
        fontSize: "55px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.55px",
      }
    : {
        color: "forground",
        fontFamily: "Poppins, sans-serif",
        fontSize: "40px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.4px",
      };

const getHeadingResponsive = (size: HeadingSize) =>
  size === "large"
    ? {
        desktop: { fontSize: "45px", lineHeight: "45px" },
        mobile: { fontSize: "40px", lineHeight: "40px" },
      }
    : {
        desktop: { fontSize: "34px", lineHeight: "34px" },
        mobile: { fontSize: "30px", lineHeight: "30px" },
      };

const termsParagraphStyles = {
  color: "forground",
  fontFamily: "Poppins, sans-serif",
  fontSize: "28px",
  fontWeight: 400,
  lineHeight: "40px",
  letterSpacing: "-0.28px",
};

const termsParagraphResponsive = {
  desktop: { fontSize: "24px", lineHeight: "36px" },
  mobile: { fontSize: "18px", lineHeight: "24px" },
};

const createPointersLinstingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    padding: "120px 0",
    width: "100%",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "80px 0", maxWidth: "95%", margin: "0 auto" },
    mobile: { padding: "40px 0", maxWidth: "95%", margin: "0 auto" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1339px",
        margin: "0 auto",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "60px 0",
            color: "forground",
          },
          responsiveStyles: {
            tablet: { gap: "40px 0" },
          },
          children: termsSections.map((section) => ({
            id: generateId(),
            type: "container" as ElementType,
            styles: { display: "flex", flexDirection: "column", gap: "30px 0" },
            responsiveStyles: {
              tablet: { gap: "22px 0" },
              mobile: { gap: "18px 0" },
            },
            children: [
              {
                id: generateId(),
                type: "heading" as ElementType,
                content: section.heading,
                styles: getHeadingStyles(section.headingSize),
                responsiveStyles: getHeadingResponsive(section.headingSize),
              },
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px 0",
                },
                responsiveStyles: {
                  desktop: { gap: "18px 0" },
                  mobile: { gap: "10px 0" },
                },
                children: section.contents.map((content) => ({
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content,
                  styles: termsParagraphStyles,
                  typography: "Body",
                  responsiveStyles: termsParagraphResponsive,
                })),
              },
            ],
          })),
        },
      ],
    },
  ],
});

const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "72px 0 36px 0" },
    mobile: { margin: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "forground",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createScientificRefListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "60px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "32px 0" },
    mobile: { margin: "24px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px", maxWidth: "95%" },
        mobile: { gap: "12px", maxWidth: "95%" },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
          },
          responsiveStyles: {
            tablet: { gap: "18px", flexDirection: "column" },
            mobile: { gap: "12px", flexDirection: "column" },
          },
          children: [
            // First Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
            // Second Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "0 72px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              // href: "#product-label",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup: "fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "background",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "rgba(0, 0, 0, 0.60)",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

export const template1terms = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    infoHeaderSection: createInfoHeaderSection(globalConfig),
    pointersListingsSection: createPointersLinstingSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
